import { render } from "./side-nav-top-toolbar.vue?vue&type=template&id=2628f4be"
import script from "./side-nav-top-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-top-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-top-toolbar.vue?vue&type=style&index=0&id=2628f4be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__